import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';

import type {MeetingFragment} from 'nutshell-graphql-types';

import {ShareMeetingModalComponent} from './share-meeting-modal-component';

type Props = {
    meeting: MeetingFragment;
};

export function ShareMeetingButton(props: Props) {
    const [isViewingShareModal, setIsViewingShareModal] = React.useState<boolean>(false);

    const closeShareModal = () => {
        setIsViewingShareModal(false);
    };

    const openShareModal = () => {
        setIsViewingShareModal(true);
    };

    return (
        <>
            {NutClientConfig.canUseScheduler ? (
                <Button onClick={openShareModal} size='big' variant='primary'>
                    Share
                </Button>
            ) : (
                <Button onClick={openShareModal} size='big' variant='primary'>
                    <div className='flex gap-4'>
                        Share
                        <UpgradeArrowIcon alignCenter={true} size={16} color={colors.blue} />
                    </div>
                </Button>
            )}
            {isViewingShareModal ? (
                <ShareMeetingModalComponent
                    meetingIsActive={props.meeting.isActive}
                    publicMeetingLink={props.meeting.publicMeetingLink}
                    embedSnippet={props.meeting.embedSnippet}
                    onClose={closeShareModal}
                    isOpen={isViewingShareModal}
                />
            ) : null}
        </>
    );
}
